import React from 'react';
import { IconContext } from 'react-icons';
import { Link } from 'react-router-dom';
import { EventLink } from '../EventLink';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import './EventRow.css';

export interface Props {
  id: string;
  eventTitle: string;
  lastSeen: string;
  severity: string;
  resolved: boolean;
  events: number;
  onIncidentOpen(): void;
  onResolve(): void;
}

export const EventRow = (props: Props) => {
  const columnClass = 'event-row__element';
  const columnClassDesktop = columnClass + ' event-row--desktop-only';
  const { id, eventTitle, lastSeen, severity, resolved, events, onIncidentOpen, onResolve } = props;

  return (
    <div key={id} className="event-row">
      <div className={columnClass} onClick={onIncidentOpen}>
        <EventLink title={eventTitle} />
      </div>
      <div className={columnClassDesktop}>{lastSeen}</div>
      <div className={columnClassDesktop}>{events}</div>
      <div className={columnClassDesktop}>{severity}</div>
      <div className={columnClass}>{resolved ? 'yes' : 'no'}</div>
      <div className={columnClass}>
        <IconContext.Provider value={{ color: '#0295a6', size: '2.5rem' }}>
          <span className="event-row__icon" onClick={onResolve}>
            <IoMdCheckmarkCircleOutline />
          </span>
        </IconContext.Provider>
      </div>
    </div>
  );
};
